import { render, staticRenderFns } from "./MessageButton.vue?vue&type=template&id=78ccbc90&scoped=true&"
import script from "./MessageButton.vue?vue&type=script&lang=ts&"
export * from "./MessageButton.vue?vue&type=script&lang=ts&"
import style0 from "./MessageButton.vue?vue&type=style&index=0&id=78ccbc90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ccbc90",
  null
  
)

export default component.exports